import api from "./api";

interface Plan {
  plan: number;
  auto_payment?: boolean;
  coupon?: string | null;
}

interface OrderResponse {
  order_url: string;
}

interface CancelAutoPaymentResponse {
  success: boolean;
}

class PaymentService {
  // Получить список тарифов
  async getPlans(): Promise<Plan[]> {
    const res = await api.get("/api/v1/plans/");
    return res.data as Plan[];
  }

  // Создание заказа
  async createOrder(payload: Plan): Promise<OrderResponse> {
    const res = await api.post("/api/v1/plan-order/", payload);
    return res.data as OrderResponse;
  }

  // Проверка наличия подписки
  async getMemberships(): Promise<any[]> {
    const res = await api.get("/api/v1/memberships/");
    return res.data as any[];
  }

  async cancelAutoPayment(): Promise<CancelAutoPaymentResponse> {
    const res = await api.post("/api/v1/plan-order/cancel-auto-payment/");
    return res.data as CancelAutoPaymentResponse;
  }
}

export default new PaymentService();
